import apiService from "../../service/apiService";
import newcustomer from "@/constants/newcustomer";
import {cloneDeep} from "lodash";
import moment from "moment/moment";

export default {
    namespaced: true,
    state: () => ({
        branch_credits: [],

        branch_credit_filters:{
            branch_id:'',

            status:'',



            page:1,


        }


    }),
    mutations: {



    },
    actions: {






    },
    getters: {}
}
